import { render, staticRenderFns } from "./CandidatesFilterButton.vue?vue&type=template&id=42770c04&"
import script from "./CandidatesFilterButton.vue?vue&type=script&lang=js&"
export * from "./CandidatesFilterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports